export default {"src":"/_next/static/media/cat-plus.77e74bfd.svg","height":812,"width":900};